import Vue from "vue";
let currentRequest = 0;

const TaggingService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("taggings", id);
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START TAGGING `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "taggings",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] TAGGING DISCARDED`);
        return null;
      }
      console.log(`[${request}] END TAGGING `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  }
};

export { TaggingService };
